import React, { createContext, useMemo, useState } from "react";
import { IServiceConfig, IServiceEndPoint, IServiceResponse, IServiceSendOptions, TypeRuningEnv } from "./ElmerService";

interface IApiHandlerOptions {
    sendOptions: IServiceSendOptions;
    isError: boolean;
    extra?: any;
    preventDefault: boolean;
}

export type IApiHandle = (data: any, response: IServiceResponse, options: IApiHandlerOptions) => any;

export interface IServiceNamespaceEx<Host extends Object, HostKeys extends keyof Host> {
    host?: { [H in HostKeys]?: string };
    isDummy?: boolean;
    endPoints: Record<string, IServiceEndPoint>;
    options?: any;
    withCredentials?: boolean;
};

export interface IServiceConfigEx<ENV extends Object, ENVKeys extends keyof ENV> {
    env?: ENVKeys;
    isDummy?: boolean;
    host: { [H in ENVKeys]?: string };
    config: Record<string, IServiceNamespaceEx<ENV, ENVKeys>>;
    timeout?: number;
};

export interface IServiceContext<ENV extends keyof TypeRuningEnv> {
    config: IServiceConfig<ENV>;
    handler: IApiHandle[];
}

export const ServiceContext = createContext<IServiceContext<keyof TypeRuningEnv>>({} as any);


export const createService = <ENV extends keyof TypeRuningEnv>(config: IServiceConfig<ENV>, responseHandle?: IApiHandle[]): React.ComponentType<any> => {
    const newConfig = {...config, env: config.env || "PROD"};
    return ({children}: any) => {
        const [ configData ] = useState(newConfig);
        const serviceContext = useMemo(() => ({
            config: configData as any,
            handler: responseHandle ?? []
        }), [configData]);
        return <ServiceContext.Provider value={serviceContext}>{children}</ServiceContext.Provider>
    };
}

export const createServiceFromHost = <Host extends {}>(host: Host) => {
    return (config: IServiceConfigEx<Host, keyof Host>, responseHandle?: IApiHandle[]): React.ComponentType<any> => {
        return createService(config as any, responseHandle);
    }
};